/* eslint-disable react/no-array-index-key */
import { PropsWithChildren } from 'react';

import { PropsWithTestAttribute } from 'types/testAttribute';

import { GridStyled } from './GridFields.styles';

export interface GridFieldsProps extends PropsWithChildren {
  minWidth?: number;
}

export const GridFields = ({
  children,
  minWidth,
  datax,
}: GridFieldsProps & PropsWithTestAttribute) => (
  <GridStyled datax={datax} minWidth={minWidth}>
    {children}
  </GridStyled>
);
